export default "__VITE_ASSET__CUpykrJF__"